import { userState } from "./users/state";
import { generalState } from "./general/state";
import { invoiceProjectsState } from "./invoice-projects/state";
import { bookingSettingsState } from "./booking/state";
import { accountingSettingsState } from "./accounting/state";
import { billingSettingsState } from "./billing/state";
import { labelSettingsState } from "./label/state";
import { custom_textsSettingsState } from "./custom_texts/state";
import { noticesSettingsState } from "./notices/state";
import { languageSettingsState } from "./language/state";
import { sharingSettingsState } from "./sharing/state";
import {promotionSettingsState} from "./promotion/state"
import { externalUserState } from "./externalusers/state";
import { taskSettingsState } from "./task/state";
export const state = {
  ...userState,
  ...generalState,
  ...invoiceProjectsState,
  ...bookingSettingsState,
  ...accountingSettingsState,
  ...billingSettingsState,
  ...labelSettingsState,
  ...custom_textsSettingsState,
  ...noticesSettingsState,
  ...languageSettingsState,
  ...sharingSettingsState,
  ...promotionSettingsState,
  ...externalUserState,
  ...taskSettingsState
};
